import { Directive, HostBinding } from '@angular/core';

@Directive({
  // tslint:disable:directive-selector
  selector: '[ls-heading1]'
})
export class Heading1Directive {
  @HostBinding('class.cr-text--heading1') public heading1 = true;
}
